import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getShortString } from 'utils/string';
import {
  Header1,
  Header2,
  Header3,
  Header4,
  Span,
  Paragraph,
  ellipsisMixin,
  sizeMixin,
  fontMixin
} from './Text.styled';

const components = {
  h1: Header1,
  h2: Header2,
  h3: Header3,
  h4: Header4,
  p: Paragraph,
  span: Span
};

export class Text extends React.PureComponent {
  refElement;

  componentDidMount() {
    if (
      this.props.appearance === 'h1' ||
      this.props.appearance === 'h2' ||
      this.props.appearance === 'h3'
    ) {
      this.refElement.focus();
    }
  }

  render() {
    const { appearance, children, maxLength, font, ...other } = this.props;
    if (maxLength && typeof children === 'string') {
      this.children = getShortString(children, maxLength);
    }
    let Wrapper = styled(components[appearance])`
      ${font && fontMixin(font)};
      ${p => p.ellipsis && ellipsisMixin};
      ${p => p.size && sizeMixin(p.size)};
    `;
    return (
      <Wrapper
        innerRef={node => {
          this.refElement = node;
        }}
        {...other}
      >
        {children}
      </Wrapper>
    );
  }
}

Text.propTypes = {
  appearance: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'span', 'p']),
  ellipsis: PropTypes.bool,
  children: PropTypes.node,
  maxLength: PropTypes.number,
  size: PropTypes.number,
  font: PropTypes.string
};

Text.defaultProps = {
  appearance: 'span'
};

export default Text;
